/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Match a reusable category across property-specific namespaces.
 */
export type PropertySharingAnyNamespace = {
    /**
     * Unrestricted namespace selection.
     */
    mode: PropertySharingAnyNamespace.mode;
};
export namespace PropertySharingAnyNamespace {
    /**
     * Unrestricted namespace selection.
     */
    export enum mode {
        ANY = 'any',
    }
}

